import './App.css';
import Header from "./Components/Header/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// v6 --> Routes | v5 --> Switch | currently we'r using 'react-router-dom' version 6
import SimpleBottomNavigation from './Components/MainNav/MainNav';
import { Container } from '@mui/system';
import Search from './Pages/Search/Search';
import About from './Pages/About/About';

function App() {
  return (
    <BrowserRouter>
    <Header/>
    <div className="app">
      <Container>
        <Routes>
          <Route path='/' element={<Search/>} /> // it is a self closing tag
          <Route path='/About' element={<About/>} /> 
        </Routes>
      </Container>
    </div>
    <SimpleBottomNavigation/>
    </BrowserRouter>
  );
}

export default App;
